"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloorRenderer = void 0;
const IsoPoint_1 = require("../../../engine/lib/IsoPoint");
const FloorUtils_1 = require("../../../engine/lib/util/FloorUtils");
const Matrix_1 = require("../../../engine/lib/util/Matrix");
const room_constants_1 = require("../room.constants");
const Floor_1 = require("./Floor");
const ladders_1 = __importDefault(require("./ladders"));
const { TOP_LEFT, TOP, TOP_RIGHT, LEFT, CENTER, RIGHT, BOTTOM_LEFT, BOTTOM, BOTTOM_RIGHT } = Matrix_1.Matrix.NEIGHBORS;
const neighborsItems = [TOP_LEFT, TOP, TOP_RIGHT, LEFT, CENTER, RIGHT, BOTTOM_LEFT, BOTTOM, BOTTOM_RIGHT];
const NEIGHBOR_BOUNDS = 3;
class FloorRenderer {
    constructor(roomEngine) {
        this.roomEngine = roomEngine;
    }
    getStairType(blocks) {
        const hasLadder = FloorUtils_1.createFloorTestFunction(blocks);
        const l = ladders_1.default.find(l => hasLadder(l.test));
        const stairType = l && l.value;
        const offset = l && l.offset;
        return {
            stairType,
            offset: Object.assign({ x: 0, y: 0, z: 0 }, {}, offset),
        };
    }
    renderFloor() {
        this.tiles = this.roomEngine.heightmap.map((z, x, y) => {
            var _a, _b, _c, _d, _e, _f;
            if (z <= 0)
                return null;
            const neighbors = Matrix_1.Matrix.from(this.roomEngine.heightmap.neighborsOf(x, y, neighborsItems), NEIGHBOR_BOUNDS, NEIGHBOR_BOUNDS);
            const { stairType, offset } = this.getStairType(neighbors);
            const isStair = stairType === undefined;
            const texture = isStair
                ? this.roomEngine.roomImager.generateFloorTileTexture()
                : this.roomEngine.roomImager.generateStairTexture(stairType);
            const zPos = isStair ? (z - 1) * 32 + 8 : z * 32;
            const position = new IsoPoint_1.IsoPoint(x * 32, y * 32, zPos);
            position.add(offset);
            const tile = new Floor_1.Floor(texture, position);
            const { wallRenderer } = this.roomEngine;
            const isDoor = x === ((_a = wallRenderer.door) === null || _a === void 0 ? void 0 : _a.x) && y === ((_b = wallRenderer.door) === null || _b === void 0 ? void 0 : _b.y);
            const inBound = wallRenderer.walls.get(x + 1, y) || wallRenderer.walls.get(x, y + 1);
            const priority = isDoor && inBound ? room_constants_1.PRIORITY.FLOOR_DOOR : room_constants_1.PRIORITY.FLOOR;
            if (((_c = wallRenderer.spawn) === null || _c === void 0 ? void 0 : _c.x) === x && ((_d = wallRenderer.spawn) === null || _d === void 0 ? void 0 : _d.y) === y)
                tile.tint = 0xff0000;
            tile.zIndex = (_f = (isDoor ? (_e = wallRenderer.walls.get(x + 1, y)) === null || _e === void 0 ? void 0 : _e.zIndex : null)) !== null && _f !== void 0 ? _f : this.roomEngine.calcZIndex(position, priority);
            this.roomEngine.container.addChild(tile);
            tile.addListener('pointertap', () => {
                this.roomEngine.currentUser.moveTo(position);
            });
            return tile;
        });
    }
}
exports.FloorRenderer = FloorRenderer;
